(function ($, window) {
    "use strict";

    $(function () {

        var mobilePreviewUrlQuery = 'cmsPreview';
        var previewScreen = '';
        var previewApp = {};

        function init(hash) {
            previewScreen = hash.replace('#', '');

            if (!window.mobilePreview || !window.mobilePreview[previewScreen]) {
                // TODO - reporting
                return;
            }

            setPreviewNavigation();
            listenToParent();
            removeMobileCookie();

            previewApp = window.mobilePreview[previewScreen].init();
            window.parent.postMessage("ready", "*");
        }

        function setPreviewNavigation() {
            $('a').each(function () {
                var $el = $(this);
                var url = $el.attr('href') + '?' + mobilePreviewUrlQuery + '=1#' + previewScreen;
                $el.attr('href', url);
            });
            $('#cc-m-container').addClass('preview');
        }

        function listenToParent() {
            bindMsg(function (str) {
                var obj = msgToObj(str);
                if (obj.action) {
                    previewApp[ obj.action ](obj.dat);
                }
            });
        }

        function bindMsg(eventHandler) {
            if (window.addEventListener) {
                window.addEventListener('message', eventHandler, false);
            } else if (window.attachEvent) {
                window.onmessage = function () {
                    eventHandler(event);
                };
            }
        }

        function msgToObj(msg) {
            var obj = {};
            // if a normal object take the string, if IE, no object just a string
            if (msg.data) {
                msg = msg.data;
            }

            // google maps posting some bad json str, expecting to eval and not parse..
            try {
                obj = JSON.parse(msg);
            } catch (e) {
                obj = {error: e};
            }
            return obj;
        }

        function removeMobileCookie() {
            try {
                document.cookie = 'mobile' + '=; expires=Thu, 01 Jan 1970 00:00:01 GMT;';
            } catch (e) {
            }
        }

        if (document.location.href.indexOf(mobilePreviewUrlQuery) > 0) {
            init(document.location.hash);
        }

    });



})(jQuery, window);



/*****************
 ** WEBPACK FOOTER
 ** ./webserver/document_root/s/js/web/mobile/mobilePreview.js
 ** module id = 3711
 ** module chunks = 100
 **/